import { getLpSectionFromElement, scrollToLpSection } from '@theme/lp-scroll-utils';

/**
 * Quiz LP : choix poids → scroll étape suivante → Oui/Non.
 */
function scrollToQuizStep(element) {
  const section = getLpSectionFromElement(element);
  if (!section) return;

  scrollToLpSection(section);
}

function initLpDestinationQuiz() {
  const choices = document.querySelectorAll('[data-lp-quiz-choice]');
  const submits = document.querySelectorAll('[data-lp-quiz-submit]');

  if (!choices.length) return;

  const scrollTargetId = choices[0]?.dataset.scrollTarget || 'signes';

  choices.forEach((button) => {
    button.addEventListener('click', () => {
      const destination = button.dataset.destination?.trim();
      if (!destination) return;

      choices.forEach((choice) => {
        choice.classList.toggle('is-selected', choice === button);
        choice.setAttribute('aria-pressed', choice === button ? 'true' : 'false');
      });

      submits.forEach((link) => {
        link.href = destination;
      });

      const target = document.getElementById(scrollTargetId);
      scrollToQuizStep(target);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLpDestinationQuiz);
} else {
  initLpDestinationQuiz();
}

export { scrollToQuizStep, getLpSectionFromElement };
